import { useEffect, useMemo, useState } from 'react';
import { ZOOM_TO_CHANGE } from '../constants';

export const useZoomDetector = (zoomToChange = ZOOM_TO_CHANGE) => {
  const [zoom, setZoom] = useState(window.devicePixelRatio * 100);
  useEffect(() => {
    const getZoom = () => {
      setZoom(Math.round(window.devicePixelRatio * 100));
    };
    window.addEventListener('resize', getZoom, false);

    return () => {
      window.removeEventListener('resize', getZoom);
    };
  }, []);

  const shouldRestyle = useMemo(
    () => zoom >= zoomToChange,
    [zoom, zoomToChange],
  );

  return { shouldRestyle, zoom };
};

export const useZoomDetectorOnSite = () => {
  const { shouldRestyle } = useZoomDetector();

  useEffect(() => {
    const root = document.getElementById('root');
    if (shouldRestyle) {
      if (root) {
        root.classList.add('zoom-styled');
      }
    } else if (root) {
      root.classList.remove('zoom-styled');
    }
  }, [shouldRestyle]);
};
